import { render, staticRenderFns } from "./stuCount.vue?vue&type=template&id=2dd5277c&scoped=true"
import script from "./stuCount.vue?vue&type=script&lang=js"
export * from "./stuCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd5277c",
  null
  
)

export default component.exports